// src/api/announcementApi.ts
import api from './api';
import { Announcement } from '../types/announcement';

const announcementApi = {
  // Currently-showing announcements for the header (every logged-in user).
  getActive: async (): Promise<Announcement[]> => {
    const res = await api.get('/announcements/active');
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  },

  // Management list (managers see all; others see active only).
  getAll: async (): Promise<Announcement[]> => {
    const res = await api.get('/announcements/');
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  },

  getById: async (id: string): Promise<Announcement> => {
    const res = await api.get(`/announcements/${id}`);
    return res.data;
  },

  // Manage-gated on the backend (403 otherwise).
  create: async (data: Omit<Announcement, 'id'>): Promise<Announcement> => {
    const res = await api.post('/announcements/', data);
    return res.data;
  },

  update: async (id: string, data: Partial<Announcement>): Promise<Announcement> => {
    const res = await api.put(`/announcements/${id}`, data);
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/announcements/${id}`);
  },
};

export default announcementApi;
